module.exports = __webpack_public_path__ + "static/media/ym-logo.cac04949.svg";